import script from "./inventoryList.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryList.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryList.vue?vue&type=style&index=0&id=364b558c&lang=scss"
import "./inventoryList.vue?vue&type=style&index=1&id=364b558c&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364b558c"]])

export default __exports__